import { render, staticRenderFns } from "./UserFamilyInfo.vue?vue&type=template&id=1aee4818&"
import script from "./UserFamilyInfo.vue?vue&type=script&lang=js&"
export * from "./UserFamilyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports